import {debounce} from "./debounce";

export function integrationsSlider() {
    const sliderWrap = $('.integrations-sliders');
    const sliders = sliderWrap.find('.slider');
    const slidersClone = sliderWrap.html();
    const breakpoint = 1024;
    let isDestroyed = false;

    function sliderInit(slider) {
        slider.each(function () {
            const slider = $(this);
            const direction = window.innerWidth < breakpoint ? slider.data('direction-mobile') : slider.data('direction-desktop');
            slider.infiniteslide({
                direction: direction,
                speed: 30,
                pauseonhover: false
            });
        });
    }

    function sliderDestroy(slider) {
        $(slider).closest(sliderWrap).html(slidersClone);
    }

    function sliderActions(flag){
        sliderDestroy($('.integrations-sliders .slider'));
        setTimeout(function () {
            sliderInit($('.integrations-sliders .slider'));
            isDestroyed = flag;
        }, 300);
    }

    $(window).on("load", function () {
        sliderInit(sliders);
    });

    $(window).on('resize', debounce(function () {
        if (window.innerWidth <= breakpoint && !isDestroyed) {
            sliderActions(true);
        }
        if (window.innerWidth >= breakpoint && isDestroyed) {
            sliderActions(false);
        }
    }));
}



// WEBPACK FOOTER //
// ./assets/js/modules/integrationsSlider.js